/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import pako from 'pako';

const decompressObject = <T>(compressedValue: string): T => {
  const compressedBytes = Uint8Array.from(atob(compressedValue), (c) => c.charCodeAt(0));
  const decompressedBytes = pako.inflate(compressedBytes);
  const decompressedValue = new TextDecoder().decode(decompressedBytes);
  const parsedVal = JSON.parse(decompressedValue) as T;

  return parsedVal;
};

export default decompressObject;
